module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="button-wrap"><legend>'+
((__t=( i18n.tc("UnitNativeChoice", "Set up a new device") ))==null?'':__t)+
'</legend><div class="no-toyota"><label>'+
((__t=( i18n.tc("Opening", "Subscription devices (GSM):") ))==null?'':__t)+
'</label> <button class="input primary" data-click="native-search">'+
((__t=( i18n.tc("Opening", "Enter serial number") ))==null?'':__t)+
'</button></div><div><label>'+
((__t=( i18n.tc("Opening", "Bluetooth Hub:") ))==null?'':__t)+
'</label> <button class="input primary" data-click="native-bluetooth">'+
((__t=( i18n.tc("Opening", "Search") ))==null?'':__t)+
'</button></div></fieldset>';
}
return __p;
};
